"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _default = [
    {
        id: "ic-1",
        wrestlerIds: [
            "gunther"
        ],
        championshipId: "ic",
        startDate: new Date("Jun 10, 2022")
    },
    {
        id: "ic-2",
        wrestlerIds: [
            "ricochet"
        ],
        championshipId: "ic-2b",
        startDate: new Date("Mar 4, 2022"),
        endDate: new Date("Jun 10, 2022")
    },
    {
        id: "ic-3",
        wrestlerIds: [
            "sami-zayn"
        ],
        championshipId: "ic",
        startDate: new Date("Feb 18, 2022"),
        endDate: new Date("Mar 4, 2022")
    },
    {
        id: "ic-4",
        wrestlerIds: [
            "shinsuke-nakamura"
        ],
        championshipId: "ic",
        startDate: new Date("Aug 13, 2021"),
        endDate: new Date("Feb 18, 2022")
    },
    {
        id: "ic-5",
        wrestlerIds: [
            "apollo-crews"
        ],
        championshipId: "ic",
        startDate: new Date("Apr 11, 2021"),
        endDate: new Date("Aug 13, 2021")
    },
    {
        id: "ic-6",
        wrestlerIds: [
            "big-e"
        ],
        championshipId: "ic",
        startDate: new Date("Dec 25, 2020"),
        endDate: new Date("Apr 11, 2021")
    },
    {
        id: "ic-7",
        wrestlerIds: [
            "sami-zayn"
        ],
        championshipId: "ic",
        startDate: new Date("Sep 27, 2020"),
        endDate: new Date("Dec 25, 2020")
    },
    {
        id: "ic-7a",
        wrestlerIds: [
            "jeff-hardy"
        ],
        championshipId: "ic",
        startDate: new Date("Aug 21, 2020"),
        endDate: new Date("Sep 27, 2020")
    }
];
